import { useEffect } from 'react';

import { FULL_WIDTH_BREAK_POINT } from '~/embed/constants';
import { isEmbedScriptMessageData } from '~/embed/utils';
import { setContentWidth, setIsFullWidth, setIsOpen } from '~/store/embed';

export const EmbedScriptListener = () => {
  useEffect(() => {
    const onWindowMessage = (message: MessageEvent<unknown>) => {
      const { data } = message;

      if (!isEmbedScriptMessageData(data)) {
        return;
      }

      switch (data.type) {
        case 'onResize':
          setContentWidth(data.payload);
          setIsFullWidth(data.payload <= FULL_WIDTH_BREAK_POINT);
          break;

        case 'onDrawerTransitionEnd':
          setIsOpen(data.payload.isOpen);
          break;

        default:
          // @ts-expect-error - This is a catch-all for unknown message types
          console.warn(`Unknown message type: ${data.type}`);
          break;
      }
    };

    window.addEventListener('message', onWindowMessage);

    return () => {
      window.removeEventListener('message', onWindowMessage);
    };
  }, []);

  return null;
};
